<!-- 
  Layout in _Account.cshtml needs to be ported, and the route needs to be ported to ngxapphost, before 
  we do that we need to determine if there are any scripts in _Account.cshtml that are needed that 
  are not a part of _Layout.cshtml. This doesn't block removing AJS, so will 
  be done in a later PR cleaning up the cshtml pages in general. 
-->

<router-outlet></router-outlet>
